import { Search } from "@material-ui/icons";
import { Fab, Grid, TextField, Tooltip } from "@mui/material";
import Select from "components/select/Select";
import { ALL_OPTION, CALL_FLOW_STATUS_OPTIONS, LIST_CALL_TYPE } from "constant";
import { useFormik } from "formik";
import { useGetListProvince } from "service/query/common.query";
import { getSelectFieldProps, getTextFieldProps } from "ultis/form";

import { useListPhoneNumberByContactCenter } from "../hooks/useListPhoneNumberByContactCenter";

const CallFlowFilter = ({ onSubmit }) => {
  const { data: listProvince } = useGetListProvince({
    filter: { where: { isCskh: true } },
  });

  const formik = useFormik({
    initialValues: {
      contactCenter: ALL_OPTION.value,
      callFlowId: "",
      callType: ALL_OPTION.value,
      number: ALL_OPTION.value,
      status: ALL_OPTION.value,
    },
    onSubmit,
  });

  const { listPhoneNumberByContactCenter } = useListPhoneNumberByContactCenter({
    callType: formik.values.callType,
    listProvince,
    contactCenter: formik.values.contactCenter,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Select
            {...getSelectFieldProps(formik, "contactCenter")}
            onChange={async (newValue) => {
              await formik.setFieldValue("contactCenter", newValue);
              await formik.setFieldValue("number", ALL_OPTION.value);
            }}
            label="Bộ phận"
            options={listProvince?.map((item) => ({
              label: item.name,
              value: item.code,
            }))}
            showAllOption
            allowClear
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            {...getTextFieldProps(formik, "callFlowId")}
            label="Mã call flow"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Select
            {...getSelectFieldProps(formik, "callType")}
            onChange={async (newValue) => {
              await formik.setFieldValue("callType", newValue);
              await formik.setFieldValue("number", ALL_OPTION.value);
            }}
            label="Loại cuộc gọi"
            options={LIST_CALL_TYPE}
            showSearch={false}
            showAllOption
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Select
            {...getSelectFieldProps(formik, "number")}
            label="Đầu số"
            options={listPhoneNumberByContactCenter?.map((item) => ({
              label: item,
              value: item,
            }))}
            showAllOption
            allowClear
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Select
            {...getSelectFieldProps(formik, "status")}
            label="Trạng thái"
            options={CALL_FLOW_STATUS_OPTIONS}
            showAllOption
            showSearch={false}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Tooltip title="Tìm kiếm">
            <Fab color="primary" aria-label="Search" type="submit">
              <Search />
            </Fab>
          </Tooltip>
        </Grid>
      </Grid>
    </form>
  );
};

export default CallFlowFilter;
